module.exports = __webpack_public_path__ + "static/img/system.c3bca41b.png";